var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("quote-builder-labour-item-template", {
    staticClass: "bb-grey-1 pb-2 mb-2 quote-item-heading",
    class: `quote-item-heading-${_vm.$theme.name}`,
    attrs: {
      "is-full-width": _vm.isFullWidth,
      "is-header": true,
      "is-quote-hour": _vm.isQuoteHour,
      "is-paint-item": _vm.isPaintItem,
      "show-paint-loading": _vm.showLoading,
      "is-ntar": _vm.isNtar,
    },
    scopedSlots: _vm._u([
      {
        key: "description",
        fn: function () {
          return [
            _c("div", { staticClass: "is-flex is-align-items-center" }, [
              _c("span", [_vm._v(_vm._s(_vm.name))]),
              _c("span", { staticClass: "ml-2" }, [
                _vm._v("(" + _vm._s(_vm.count) + ")"),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "loading",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-center is-align-items-center mx-2",
              },
              [_c("span", [_vm._v("Load")])]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "paint_group",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-center is-align-items-center",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("Pt Grp")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "report",
        fn: function () {
          return [
            _c("div", { staticClass: "is-flex is-align-items-center" }, [
              false ? _c("span", [_vm._v("Rpt")]) : _vm._e(),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "rates",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-end is-align-items-center mx-2",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("Rate")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "blend",
        fn: function () {
          return [
            _c("div", { staticClass: "is-flex is-align-items-center" }, [
              _vm.count >= 1 ? _c("span", [_vm._v("Blend")]) : _vm._e(),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "hour_value",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-end is-align-items-center mx-2",
              },
              [
                _vm.count >= 1
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.isQuoteHour ? _vm.hourValue.toFixed(2) : "Value"
                        )
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "total_value",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-end is-align-items-center",
              },
              [
                _vm.count >= 1
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.totalValue,
                            _vm.$userInfo.locale
                          )
                        )
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "present_as",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-center is-align-items-center mx-2",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("Present As")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }